import { useCallback, useState } from 'react';

const useRangeChange = () => {
  const [range, setRange] = useState('TODAY');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setRange(e.target.value);
  }, []);

  const handleStartDateChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setStartDate(e.target.value);
    },
    []
  );

  const handleEndDateChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEndDate(e.target.value);
    },
    []
  );

  return {
    range,
    startDate,
    endDate,
    handleChange,
    handleStartDateChange,
    handleEndDateChange,
    setStartDate,
    setEndDate,
    isCustomRange: range === 'CUSTOM',
  };
};

export default useRangeChange;
